import { Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import roles from '../SecuredArea/roles';

export default function withSessionRedirect(WrappedComponent) {
  const Wrapper = (props) => {
    let isForceStay = false;
    if (
      props.location.pathname.includes('login_switch/') ||
      props.location.pathname.includes('resetting/') ||
      props.location.pathname.includes('setting/')
    ) {
      isForceStay = true;
    }

    return (
      <div>
        {!isForceStay && props.authenticated && !props.roles?.includes(roles['/']) && <Redirect to={{ pathname: '/403' }} />}
        {!isForceStay && props.authenticated && props.roles?.includes(roles['/']) && <Redirect to={{ pathname: '/' }} />}
        {/* eslint-disable-next-line react/jsx-props-no-spreading */}
        {(isForceStay || !props.authenticated) && <WrappedComponent {...props} />}
      </div>
    );
  };

  Wrapper.propTypes = {
    authenticated: PropTypes.bool.isRequired,
    /* eslint-disable-next-line react/forbid-prop-types */
    intl: PropTypes.object.isRequired,
  };

  return Wrapper;
}
